import { render, staticRenderFns } from "./Solicitante.vue?vue&type=template&id=3063fa70&scoped=true"
import script from "./Solicitante.vue?vue&type=script&lang=js"
export * from "./Solicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063fa70",
  null
  
)

export default component.exports